import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from "react-ga4"
import './index.css';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import { DmwaError } from "./models/DmwaError";

import reportWebVitals from './reportWebVitals';

import { ApolloClient, ApolloLink, ApolloProvider, InMemoryCache, createHttpLink } from '@apollo/client';
import { RetryLink } from 'apollo-link-retry';
import { Provider } from 'react-redux';
import { store, persistor } from './redux/store';
import { RouterProvider } from 'react-router-dom';
import { router } from './components/routes/Routes';
import { PersistGate } from 'redux-persist/integration/react';
import { getAccessToken, setToken, clearToken } from './redux/tokenSlice';
import { useAppDispatch, useAppSelector } from './redux/hooks';
import { RefreshToken } from './graphQL/api';
import { clearAppState } from './redux/appStateSlice';
import { clearBackNavigation, clearSelectedGroup } from './redux/navigationSlice';

const GA_ID = process.env.REACT_APP_GA_ID;
if (GA_ID) {
  ReactGA.initialize(GA_ID);
}

const authMiddleware = new ApolloLink((operation, forward) => {
	// add the authorization to the headers
	operation.setContext(({ headers = {} }) => ({
	  headers: {
		...headers,
		authorization: getAccessToken() || null,
	  }
	}));
  
	return forward(operation);
  })

const AppRoot = () => {

	const [hasRequestedToken, setHasRequestedToken] = useState(false)

	const bondedPairToken = useAppSelector(state => state.token.bondedPairToken)
	const dispatch = useAppDispatch();

	const retryLink = new RetryLink({
	  delay: {
	    initial: 1000,
	    max: 5000,
	    jitter: true
	  },
	  attempts: {
	    max: 2,
	    retryIf: async (error) => {
	    	if (error && error.statusCode === 401 && !hasRequestedToken) {
				setHasRequestedToken(true)
				await RefreshToken(bondedPairToken, response => {

					if (response instanceof DmwaError) {

					dispatch(clearToken());
					dispatch(clearAppState())
					dispatch(clearBackNavigation())
					dispatch(clearSelectedGroup())

	    				window.location.replace(`${process.env.REACT_APP_AUTH_ERROR_URL}`)
					} else {
						const newBondedPair = response?.data?.tokens;
						setHasRequestedToken(false)
						if (newBondedPair) {
							dispatch(setToken(newBondedPair))
						}
					}
				})
				return true;
	      	} else {
				return false //Only retry for 401 for now
			}
	    },
	  },
	});

	// Create an HTTP link for your GraphQL endpoint
	const httpLink = createHttpLink({
		uri: process.env.REACT_APP_GRAPHQL_URL, // Replace with your GraphQL endpoint
		defaultOptions: {
			watchQuery: {
				nextFetchPolicy: 'network-only',
			},
		}
	});

	// Create the Apollo client with the retry link and other necessary configurations
	var apolloClient = useRef(new ApolloClient({
		// link: retryLink.concat(httpLink),
		link: ApolloLink.from([
			retryLink,
			authMiddleware,
			httpLink
		]),
		cache: new InMemoryCache(),		
	})) 

	return (
		<ApolloProvider client={apolloClient.current}>
			<RouterProvider router={router} />
		</ApolloProvider>
	)
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<AppRoot />
			</PersistGate>
		</Provider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
